import React from 'react';
import {Typography} from "@mui/material";
import clsx from "clsx";
import {getStore} from "trim-redux";
import {getDirection} from "../../../config/design/theme";

export default function SubTitle(props) {
    return (
        <Typography
            style={props.style}
            component={!!props.component ? props.component : "h3"}
            variant="subtitle1"
            className={clsx("subheading",props.className)}
            color={props.color}
            align={props.align ? getDirection() === "rtl" ? props.align === "left" ? "right" : "left" : props.align : "center"}
            gutterBottom
        >
            {props.children} {props.required ? " *" : null}
        </Typography>
    );
}
